<template>
  <tr v-if="!!(vm && vm.os)">
    <td>
      <b>{{$t('management.customOs.osImageName')}}</b>
    </td>
    <td>
      <div class="d-flex flex-column flex-md-row form-group form-group-w-btn" style="margin: 0">
        <p>{{formatOsName(vm.os.ide2) ? formatOsName(vm.os.ide2) : 'management.customOs.osImageNameNone' | translate}}</p>
        <div
          style="max-width: 150px"
        >
          <button
            :disabled="formatOsName(vm.os.ide2) === null"
            class="btn btn-primary btn-micro"
            style="margin-left: 10px"
            @click="formUnmountIsoImage()"
          >
            <div class="btn-with-icon-content">
              {{$t('management.customOs.unmount')}}
            </div>
          </button>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
  import {getAxios} from 'services/ajax'

  export default {
    name: "CustomIsoTableSettings",
    props: {
      vm: {
        type: Object,
        default: {}
      },
    },
    methods: {
      formatOsName(string) {
        const regex = /:iso\/([^,]+)/;
        const match = string.match(regex);

        if (match) {
          return match[1];
        }

        return null
      },
      formUnmountIsoImage() {
        getAxios().delete('/custom_iso/' + this.vm.data.id)
          .then(response => {
            this.showToast(this.$t(`management.customOs.${response.data.message}`), {
              icon: 'fa-exclamation',
              position: 'top-center',
              duration: 3000,
              fullWidth: false
            })
          })
          .catch(function () {
            this.showToast(this.$t(`management.customOs.${err.response.data.message}`), {
              icon: 'fa-exclamation',
              position: 'top-center',
              duration: 3000,
              fullWidth: false
            })
          })
          .finally(() => {
            this.$emit('reloadVmSettings', true)
          });
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CustomIso/CustomIsoTableSettings.vue